import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MegaMenu extends ThemeComponent {
    @Ref({required: false}) dropdown!: HTMLElement[];

    /**
     * Initialise.
     */
    init() {
        if (window.quickLaunch.megaMenu) {
            this.handleMegaMenu();
        }
    }

    /**
     * Handle mega menu.
     */
    handleMegaMenu() {
        for(const dropdown of this.dropdown) {
            dropdown?.classList.add('site-header__dropdown--mega');
        }
    }
}
